import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-top":"30px"} }
const _hoisted_2 = { style: {"padding":"10px"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("邀请开卡")

import { reactive, ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from "vue-router"
import tools from '@/tools'

import { useUserStore } from '@/store/user'
import request from '@/plugin/request'
import work from '@/plugin/work'

import { Toast } from 'vant';


export default /*#__PURE__*/_defineComponent({
  __name: 'shop',
  setup(__props) {

const user = useUserStore()


const router = useRouter();


onMounted(async () => {

  // const params = tools.data.getUrlParams()

  await work.get_agent()

  work.check_agent()







})

const demo = () => {

  work.wecom.invoke('sendChatMessage', {
    msgtype: "news", //消息类型，必填
    enterChat: true, //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
    news: {
      link: `https://100001731369.retail.n.weimob.com/saas/retail/100001731369/2618501369/shop/index`, //H5消息页面url 必填
      title: '基家棉品', //H5消息标题
      desc: '邀请您办理会员卡', //H5消息摘要
      imgUrl: 'https://image-c.weimobwmc.com/saas-wxbiz/8a47b539aa5b469cb63cfbd6a1e80bc4.png', //H5消息封面图片URL
    }
  }, (res: any) => {
    console.log(res)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_button, {
        type: "success",
        size: "large",
        onClick: demo
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ])
  ]))
}
}

})